import { CustomErrorCodes } from "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
const getErrorCodeFromMessage = (errorMessage) => Object.values(CustomErrorCodes).find((code) => errorMessage?.includes(String(code)))?.toString();
export {
  getErrorCodeFromMessage
};
//# sourceMappingURL=utils.js.map
